import React from "react";
import { CircleMarker, Popup } from "react-leaflet";

import { useAppSelector } from "../redux/hooks";
import { selectCurrentBusData, selectTripProgressBarData } from "../redux/selectors";

const MapBusTripInfo = (): JSX.Element => {
  const currentBusDataFromRedux: BusInfo = useAppSelector<BusInfo>(selectCurrentBusData);
  const currentTripProgressBarDataFromRedux: BusStop[] = useAppSelector<BusStop[]>(selectTripProgressBarData);
  // console.log("currentTripProgressBarDataFromRedux:", currentTripProgressBarDataFromRedux);

  //* Colors - no constants
  const stopsOptions = { fillColor: "turquoise", color: "firebrick", fillOpacity: 0.8 };

  const TripStops = (): JSX.Element => {
    return (
      <React.Fragment>
        {currentTripProgressBarDataFromRedux &&
          (currentTripProgressBarDataFromRedux.map((elem: BusStop, index: number) => (
            <CircleMarker
              pathOptions={stopsOptions}
              key={String(elem.lat + " " + elem.lon + " " + index)}
              center={{
                lat: elem.lat,
                lng: elem.lon,
              }}
              radius={6}
            >
              <Popup>
                <div>
                  Name: <span className="span_bold">{elem.name}</span>
                  <br />
                  ID: <span className="span_bold">{elem.id}</span>
                  <br />
                  Departure Time: <span className="span_bold">{elem.departureTime || "n/a"}</span>
                </div>
              </Popup>
            </CircleMarker>
          )) as JSX.Element[])}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>{currentBusDataFromRedux && currentTripProgressBarDataFromRedux ? <TripStops /> : null}</React.Fragment>
  );
};

export default MapBusTripInfo;
